import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

export default {
    namespaced: true,
    state() {
        return {
            partner: {},
            partners: [],
            partnersLoaded: false,
            applications: [],
            applicationsLoaded: false,
            administrators: [],
            administratorsLoaded: false,
            transactions: [],
            transactionsTotal: 0,
            transactionsLoading: false,
            transactionsSums: {},
            commissions: [],
            commissionsLoaded: false,
            affiliates: [],
            affiliatesLoaded: false,
            applicationApprove: {}
        };
    },
    getters: getters,
    mutations: mutations,
    actions: actions
};
